import type { Clue } from '@neopolis/engine';

import { T } from '../../textes-interface.js';

/**
 * Une carte-indice : soit le témoignage d'un habitant, soit une donnée chiffrée.
 *
 * L'avatar est générique — une silhouette de couleur tirée du nom — pour ne
 * représenter personne en particulier et n'avoir aucune image à télécharger.
 */
export function CarteIndice({ indice }: { indice: Clue }) {
  if (indice.type === 'donnee') {
    return (
      <li className="rounded-xl border border-amber-200 bg-amber-50 p-3">
        <p className="text-xs font-semibold uppercase tracking-wide text-amber-800">
          <span aria-hidden="true">📊 </span>
          {T.explorer.donnee}
        </p>
        <p className="mt-1 text-slate-800">{indice.texte}</p>
      </li>
    );
  }

  return (
    <li className="rounded-xl border border-sky-200 bg-sky-50 p-3">
      <p className="text-xs font-semibold uppercase tracking-wide text-sky-800">
        <span aria-hidden="true">💬 </span>
        {T.explorer.temoignage}
      </p>
      <div className="mt-2 flex items-start gap-3">
        <span
          aria-hidden="true"
          className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-sky-200 text-lg"
        >
          🧑
        </span>
        <div className="min-w-0">
          <p className="text-slate-800">{indice.texte}</p>
          <p className="mt-1 text-sm font-medium text-slate-600">{indice.auteur}</p>
        </div>
      </div>
    </li>
  );
}
